import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Байгууллагын жагсаалт")
const _hoisted_5 = { class: "card shadow" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Төв салбарын жагсаалт")
], -1)
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Нэмэх ")
const _hoisted_10 = {
  class: "card-body",
  style: {"padding":"20px 0 10px 0"}
}
const _hoisted_11 = { style: {"padding":"0 30px"} }
const _hoisted_12 = {
  style: {"margin-top":"10px"},
  align: "center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "card shadow" }
const _hoisted_15 = { class: "card-header" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Салбарын жагсаалт")
], -1)
const _hoisted_17 = { class: "card-toolbar" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Салбар нэмэх ")
const _hoisted_19 = {
  class: "card-body",
  style: {"padding":"20px 0 10px 0"}
}
const _hoisted_20 = { style: {"padding":"0 30px"} }
const _hoisted_21 = {
  style: {"margin-top":"10px"},
  align: "center"
}
const _hoisted_22 = {
  key: 0,
  class: "modal modal-fullscreen fade",
  tabindex: "-1",
  ref: "editOrgModal",
  "aria-hidden": "true",
  style: {"z-index":"1100 !important"}
}
const _hoisted_23 = { class: "modal-dialog modal-dialog-centered mw-700px" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = { class: "modal-header" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", null, "Байгууллага засах", -1)
const _hoisted_27 = { class: "svg-icon svg-icon-1" }
const _hoisted_28 = { class: "modal-body" }
const _hoisted_29 = {
  class: "modal modal-fullscreen fade",
  tabindex: "-1",
  ref: "editOrgRespModal",
  style: {"z-index":"1200 !important"}
}
const _hoisted_30 = { class: "modal-dialog modal-dialog-centered mw-350px" }
const _hoisted_31 = { class: "modal-content" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Байгууллага засах")
], -1)
const _hoisted_33 = {
  class: "modal-body",
  align: "center"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("strong", null, "Код:", -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_36 = /*#__PURE__*/_createElementVNode("strong", null, "Нэр:", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("strong", null, "Төрөл:", -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, "Төлөв:", -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_42 = /*#__PURE__*/_createElementVNode("strong", null, "Эхэлсэн өдөр:", -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_44 = /*#__PURE__*/_createElementVNode("strong", null, "Дуусах өдөр:", -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_46 = /*#__PURE__*/_createElementVNode("strong", null, "Тайлбар:", -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_48 = { class: "modal-footer" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Хадгалах ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Болих ")
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_52 = {
  class: "row",
  style: {"padding":"10px 20px 10px 10px"}
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Хадгалах ")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Болих ")
const _hoisted_55 = {
  key: 1,
  class: "modal modal-fullscreen fade",
  ref: "deleteOrgModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_56 = { class: "modal-dialog modal-dialog-centered mw-250px" }
const _hoisted_57 = { class: "modal-content" }
const _hoisted_58 = { class: "modal-header" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("h2", null, "Устгах уу?", -1)
const _hoisted_60 = { class: "svg-icon svg-icon-1" }
const _hoisted_61 = { class: "modal-body" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("strong", null, "Код:", -1)
const _hoisted_63 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_64 = /*#__PURE__*/_createElementVNode("strong", null, "Нэр:", -1)
const _hoisted_65 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_66 = { class: "modal-footer" }
const _hoisted_67 = /*#__PURE__*/_createTextVNode("Устгах ")
const _hoisted_68 = /*#__PURE__*/_createTextVNode("Болих ")
const _hoisted_69 = {
  key: 3,
  class: "modal modal-fullscreen fade",
  tabindex: "-1",
  ref: "editBranchModal",
  "aria-hidden": "true",
  style: {"z-index":"1100 !important"}
}
const _hoisted_70 = { class: "modal-dialog modal-dialog-centered mw-700px" }
const _hoisted_71 = { class: "modal-content" }
const _hoisted_72 = { class: "modal-header" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("h2", null, "Салбар засах", -1)
const _hoisted_74 = { class: "svg-icon svg-icon-1" }
const _hoisted_75 = { class: "modal-body" }
const _hoisted_76 = {
  class: "modal modal-fullscreen fade",
  tabindex: "-1",
  ref: "editBranchRespModal",
  style: {"z-index":"1200 !important"}
}
const _hoisted_77 = { class: "modal-dialog modal-dialog-centered mw-350px" }
const _hoisted_78 = { class: "modal-content" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Салбар засах")
], -1)
const _hoisted_80 = {
  class: "modal-body",
  align: "center"
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("strong", null, "Төв салбарын код:", -1)
const _hoisted_82 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_83 = /*#__PURE__*/_createElementVNode("strong", null, "Салбарын нэр:", -1)
const _hoisted_84 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_85 = /*#__PURE__*/_createElementVNode("strong", null, "Салбарын код:", -1)
const _hoisted_86 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_87 = { class: "modal-footer" }
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Хадгалах ")
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" Болих ")
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_91 = {
  class: "row",
  style: {"padding":"10px 20px 10px 10px"}
}
const _hoisted_92 = /*#__PURE__*/_createTextVNode("Хадгалах ")
const _hoisted_93 = /*#__PURE__*/_createTextVNode("Болих ")
const _hoisted_94 = {
  key: 4,
  class: "modal modal-fullscreen fade",
  ref: "deleteBranchModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_95 = { class: "modal-dialog modal-dialog-centered mw-250px" }
const _hoisted_96 = { class: "modal-content" }
const _hoisted_97 = { class: "modal-header" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("h2", null, "Устгах уу?", -1)
const _hoisted_99 = { class: "svg-icon svg-icon-1" }
const _hoisted_100 = { class: "modal-body" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("strong", null, "Салбарын код:", -1)
const _hoisted_102 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_103 = /*#__PURE__*/_createElementVNode("strong", null, "Салбарын нэр:", -1)
const _hoisted_104 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_105 = { class: "modal-footer" }
const _hoisted_106 = /*#__PURE__*/_createTextVNode("Устгах ")
const _hoisted_107 = /*#__PURE__*/_createTextVNode("Болих ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_add_org = _resolveComponent("add-org")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_add_branch_org = _resolveComponent("add-branch-org")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-plus",
            plain: "",
            size: "small",
            "data-bs-target": "#addOrgModal",
            "data-bs-toggle": "modal"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_input_number, {
            class: "col-sm-1",
            modelValue: _ctx.pageSize,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
            onChange: _ctx.handleChange,
            style: {"width":"15%"},
            min: 1,
            max: 100,
            size: "mini"
          }, null, 8, ["modelValue", "onChange"]),
          _createVNode(_component_el_select, {
            modelValue: _ctx.selectVal,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectVal) = $event)),
            placeholder: "Select",
            filterable: "",
            size: "mini",
            style: {"float":"right"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusTypeOrg, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.selectVal,
                  label: item.selectLabel,
                  value: item.selectVal
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_input, {
            "prefix-icon": "el-icon-search",
            modelValue: _ctx.customerSearch,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customerSearch) = $event)),
            size: "mini",
            placeholder: "Хайх утга аа оруулна уу...",
            style: {"float":"right","width":"35%","margin-right":"10px"}
          }, null, 8, ["modelValue"])
        ]),
        true
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: 
            this.tableData
              .filter(data => {
                return this.selectVal === '07'
                  ? true
                  : data.orgtypecode.includes(this.selectVal);
              })
              .filter(data => {
                return (
                  !this.customerSearch ||
                  data.searchfield.includes(this.customerSearch.toLowerCase())
                );
              })
              .slice(
                this.pageSize * this.page - this.pageSize,
                this.pageSize * this.page
              )
          ,
              style: {"width":"100%","margin-top":"20px"},
              border: "",
              size: "mini",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "№",
                  width: "40",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Код",
                  prop: "orgcode",
                  sortable: "",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Нэр",
                  prop: "orgname",
                  sortable: "",
                  width: "280px"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Төрөл",
                  prop: "orgtype",
                  sortable: "",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Гэрээ эхэлсэн өдөр",
                  prop: "cstartdate",
                  sortable: "",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Гэрээ дуусах өдөр",
                  prop: "cenddate",
                  sortable: "",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Гэрээний төлөв",
                  prop: "contractstatus",
                  sortable: "",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Тайлбар",
                  prop: "description",
                  sortable: "",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Үйлдэл",
                  align: "center",
                  width: "115"
                }, {
                  default: _withCtx((props) => [
                    _createVNode(_component_el_button_group, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          icon: "el-icon-edit",
                          size: "mini",
                          plain: "",
                          onClick: ($event: any) => (_ctx.editorgshowbutton(props.row)),
                          type: "primary"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          icon: "el-icon-delete",
                          size: "mini",
                          plain: "",
                          "data-orgcode": props.row.orgcode,
                          "data-orgname": props.row.orgname,
                          onClick: _ctx.deleteorgmodalshowbutton,
                          type: "danger"
                        }, null, 8, ["data-orgcode", "data-orgname", "onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _ctx.loadingOrgTable]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_pagination, {
              layout: "total, prev, pager, next, jumper",
              onCurrentChange: _ctx.handleCurrentChange,
              "page-size": _ctx.pageSize,
              total: this.tableData.length
            }, null, 8, ["onCurrentChange", "page-size", "total"])
          ])
        ])
      ])
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-plus",
            plain: "",
            "data-bs-target": "#addBranchOrgModal",
            "data-bs-toggle": "modal",
            size: "small",
            hidden: !this.branchSelected
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["hidden"])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_input_number, {
            class: "col-sm-1",
            modelValue: _ctx.pageSizeBranch,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pageSizeBranch) = $event)),
            onChange: _ctx.handleChangeBranch,
            style: {"width":"15%"},
            min: 1,
            max: 100,
            size: "mini"
          }, null, 8, ["modelValue", "onChange"]),
          _createVNode(_component_el_select, {
            modelValue: _ctx.selectValOrg,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectValOrg) = $event)),
            placeholder: "Байгууллага сонгох",
            size: "mini",
            filterable: "",
            style: {"float":"right"},
            onChange: _ctx.handleChangeBranchAddOrgcode
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOrgList.filter(data => {
              return this.selectValBranch === '07'
                ? true
                : data.selectOrgTypeCode.includes(this.selectValBranch);
            }), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.selectValOrg,
                  label: item.selectLabelOrg,
                  value: item.selectValOrg
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createVNode(_component_el_select, {
            modelValue: _ctx.selectValBranch,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectValBranch) = $event)),
            placeholder: "Сонгох",
            size: "mini",
            filterable: "",
            style: {"float":"right","margin":"0 10px"},
            onChange: _cache[6] || (_cache[6] = ($event: any) => {
            this.selectValOrg = '';
            this.branchSelected = false;
          })
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusTypeBranch, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.selectValBranch,
                  label: item.selectLabelBranch,
                  value: item.selectValBranch
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_input, {
            "prefix-icon": "el-icon-search",
            modelValue: _ctx.customerBranchSearch,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.customerBranchSearch) = $event)),
            size: "mini",
            placeholder: "Хайх утга аа оруулна уу...",
            style: {"float":"right","width":"35%"}
          }, null, 8, ["modelValue"])
        ]),
        true
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: 
            this.tableDataBranch
              .filter(data => {
                return (
                  !this.selectValOrg ||
                  data.orgcode.toLowerCase().includes(this.selectValOrg)
                );
              })
              .filter(data => {
                return (
                  !this.customerBranchSearch ||
                  data.searchfield.includes(
                    this.customerBranchSearch.toLowerCase()
                  )
                );
              })
              .slice(
                this.pageSizeBranch * this.pageBranch - this.pageSizeBranch,
                this.pageSizeBranch * this.pageBranch
              )
          ,
              style: {"width":"100%","margin-top":"20px"},
              border: "",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              size: "mini",
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "№",
                  width: "40",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Нэр",
                  prop: "branchname",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Төв салбарын код",
                  prop: "orgcode",
                  sortable: "",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Салбарын код",
                  prop: "orgbranchcode",
                  sortable: "",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Үйлдэл",
                  width: "115",
                  align: "center"
                }, {
                  default: _withCtx((props) => [
                    _createVNode(_component_el_button_group, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          icon: "el-icon-edit",
                          size: "mini",
                          plain: "",
                          onClick: ($event: any) => (this.editbranchshowbutton(props.row)),
                          type: "primary"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          icon: "el-icon-delete",
                          size: "mini",
                          plain: "",
                          "data-orgcode": props.row.orgcode,
                          "data-branchname": props.row.branchname,
                          "data-branchcode": props.row.orgbranchcode,
                          onClick: _ctx.deletebranchmodalshowbutton,
                          type: "danger"
                        }, null, 8, ["data-orgcode", "data-branchname", "data-branchcode", "onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _ctx.loadingOrgBranchTable]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_pagination, {
              layout: "total, prev, pager, next, jumper",
              onCurrentChange: _ctx.handleCurrentChangeBranch,
              "page-size": _ctx.pageSizeBranch,
              total: this.tableDataBranch.length
            }, null, 8, ["onCurrentChange", "page-size", "total"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_add_org, { onRefreshevent: _ctx.getOrg }, null, 8, ["onRefreshevent"]),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", {
                  class: "btn btn-sm btn-icon btn-active-color-primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {
                _ctx.editorghidebutton();
                _ctx.clearField();
              })
                }, [
                  _createElementVNode("span", _hoisted_27, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_el_form, {
                  model: this.editorgmodal.modalform,
                  ref: "editorgmodalref",
                  "label-width": "220px",
                  size: "mini",
                  rules: this.editorgmodal.modalformrule
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Байгууллагын код:",
                      prop: "orgcode",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: this.editorgmodal.modalform.orgcode,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.editorgmodal.modalform.orgcode) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Байгууллагын нэр:",
                      prop: "orgname",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: this.editorgmodal.modalform.orgname,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((this.editorgmodal.modalform.orgname) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Төрөл:",
                      prop: "selectVal",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          size: "mini",
                          placeholder: "--Сонгох--",
                          modelValue: this.editorgmodal.modalform.selectVal,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((this.editorgmodal.modalform.selectVal) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.editorgmodal.modalform.selectOrgType, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.selectVal,
                                label: item.selectLabel,
                                value: item.selectVal
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Гэрээний төлөв:",
                      prop: "selectStatVal",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          size: "mini",
                          placeholder: "--Сонгох--",
                          modelValue: this.editorgmodal.modalform.selectStatVal,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((this.editorgmodal.modalform.selectStatVal) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.editorgmodal.modalform.selectOrgStat, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.selectStatVal,
                                label: item.selectStatLabel,
                                value: item.selectStatVal
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Гэрээ эхэлсэн өдөр:",
                      prop: "cstartdate",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: this.editorgmodal.modalform.cstartdate,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((this.editorgmodal.modalform.cstartdate) = $event)),
                          onChange: _ctx.startDatePicker,
                          type: "date"
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Гэрээ дуусах өдөр:",
                      prop: "cenddate",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: this.editorgmodal.modalform.cenddate,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((this.editorgmodal.modalform.cenddate) = $event)),
                          onChange: _ctx.endDatePicker,
                          type: "date"
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Тайлбар:",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: this.editorgmodal.modalform.desc,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((this.editorgmodal.modalform.desc) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_el_row, {
                              justify: "space-between",
                              type: "flex"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_34,
                                _hoisted_35,
                                _createElementVNode("p", null, _toDisplayString(this.editorgmodal.modalform.orgcode), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, {
                              justify: "space-between",
                              type: "flex"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_36,
                                _hoisted_37,
                                _createElementVNode("p", null, _toDisplayString(this.editorgmodal.modalform.orgname), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, {
                              justify: "space-between",
                              type: "flex"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_38,
                                _hoisted_39,
                                _createElementVNode("p", null, _toDisplayString(this.editorgmodal.modalform.selectVal), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, {
                              justify: "space-between",
                              type: "flex"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_40,
                                _hoisted_41,
                                _createElementVNode("p", null, _toDisplayString(this.editorgmodal.modalform.selectStatVal), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, {
                              justify: "space-between",
                              type: "flex"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_42,
                                _hoisted_43,
                                _createElementVNode("p", null, _toDisplayString(this.editorgmodal.modalform.cstartdate), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, {
                              justify: "space-between",
                              type: "flex"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_44,
                                _hoisted_45,
                                _createElementVNode("p", null, _toDisplayString(this.editorgmodal.modalform.cenddate), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, {
                              justify: "space-between",
                              type: "flex"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_46,
                                _hoisted_47,
                                _createElementVNode("p", null, _toDisplayString(this.editorgmodal.modalform.desc), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "success",
                                  size: "mini",
                                  plain: "",
                                  loading: this.editorgmodal.savebuttonloading,
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.editOrg()))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_49
                                  ]),
                                  _: 1
                                }, 8, ["loading"]),
                                _createVNode(_component_el_button, {
                                  type: "info",
                                  size: "mini",
                                  plain: "",
                                  onClick: _ctx.editorgresphidemodal
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_50
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ], 512)
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      plain: "",
                      size: "mini",
                      class: "col-lg-3",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.formSubmit()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_53
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "info",
                      plain: "",
                      size: "mini",
                      class: "col-lg-3",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => {
                  _ctx.clearField();
                  _ctx.editorghidebutton();
                })
                    }, {
                      default: _withCtx(() => [
                        _hoisted_54
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      ref: "submitValidateEditOrgButton",
                      hidden: "",
                      plain: "",
                      size: "mini",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.editorgrespshowmodal())),
                      class: "col-lg-3"
                    }, null, 512)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", {
                  class: "btn btn-sm btn-icon btn-active-color-primary",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.deleteorgmodalhidebutton()))
                }, [
                  _createElementVNode("span", _hoisted_60, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_el_row, {
                  justify: "space-between",
                  type: "flex"
                }, {
                  default: _withCtx(() => [
                    _hoisted_62,
                    _hoisted_63,
                    _createElementVNode("p", null, _toDisplayString(this.deleteorgmodal.orgcode), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  justify: "space-between",
                  type: "flex"
                }, {
                  default: _withCtx(() => [
                    _hoisted_64,
                    _hoisted_65,
                    _createElementVNode("p", null, _toDisplayString(this.deleteorgmodal.orgname), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      plain: "",
                      size: "mini",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.deleteOrg())),
                      loading: this.deleteorgmodal.savebuttonloading
                    }, {
                      default: _withCtx(() => [
                        _hoisted_67
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_el_button, {
                      type: "info",
                      plain: "",
                      size: "mini",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.deleteorgmodalhidebutton()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_68
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    (this.branchSelected)
      ? (_openBlock(), _createBlock(_component_add_branch_org, {
          key: 2,
          orgcode: this.addbranchorgcode,
          onRefreshevent: _ctx.getOrgBranch
        }, null, 8, ["orgcode", "onRefreshevent"]))
      : _createCommentVNode("", true),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _createElementVNode("div", {
                  class: "btn btn-sm btn-icon btn-active-color-primary",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => {
                _ctx.editbranchhidebutton();
                _ctx.clearFieldBranch();
              })
                }, [
                  _createElementVNode("span", _hoisted_74, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createVNode(_component_el_form, {
                  model: this.editbranchmodal.modalform,
                  ref: "editbranchmodalref",
                  "label-width": "220px",
                  size: "mini",
                  rules: this.editbranchmodal.modalformrule
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Төв салбарын код:",
                      prop: "orgcode",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: this.editbranchmodal.modalform.orgcode,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((this.editbranchmodal.modalform.orgcode) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Салбарын нэр:",
                      prop: "branchname",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: this.editbranchmodal.modalform.branchname,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((this.editbranchmodal.modalform.branchname) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Салбарын код:",
                      prop: "branchcode",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: this.editbranchmodal.modalform.branchcode,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((this.editbranchmodal.modalform.branchcode) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _hoisted_79,
                          _createElementVNode("div", _hoisted_80, [
                            _createVNode(_component_el_row, {
                              justify: "space-between",
                              type: "flex"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_81,
                                _hoisted_82,
                                _createElementVNode("p", null, _toDisplayString(this.editbranchmodal.modalform.orgcode), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, {
                              justify: "space-between",
                              type: "flex"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_83,
                                _hoisted_84,
                                _createElementVNode("p", null, _toDisplayString(this.editbranchmodal.modalform.branchname), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, {
                              justify: "space-between",
                              type: "flex"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_85,
                                _hoisted_86,
                                _createElementVNode("p", null, _toDisplayString(this.editbranchmodal.modalform.branchcode), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "success",
                                  size: "mini",
                                  plain: "",
                                  loading: this.editbranchmodal.savebuttonloading,
                                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.editBranch()))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_88
                                  ]),
                                  _: 1
                                }, 8, ["loading"]),
                                _createVNode(_component_el_button, {
                                  type: "info",
                                  size: "mini",
                                  plain: "",
                                  onClick: _ctx.editbranchresphidemodal
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_89
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ], 512)
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _hoisted_90,
              _createElementVNode("div", _hoisted_91, [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      plain: "",
                      size: "mini",
                      class: "col-lg-3",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.formSubmitBranch()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_92
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "info",
                      plain: "",
                      size: "mini",
                      class: "col-lg-3",
                      onClick: _cache[29] || (_cache[29] = ($event: any) => {
                  _ctx.editbranchhidebutton();
                  _ctx.clearFieldBranch();
                })
                    }, {
                      default: _withCtx(() => [
                        _hoisted_93
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      ref: "submitValidateEditBranchButton",
                      hidden: "",
                      plain: "",
                      size: "mini",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.editbranchrespshowmodal())),
                      class: "col-lg-3"
                    }, null, 512)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _hoisted_98,
                _createElementVNode("div", {
                  class: "btn btn-sm btn-icon btn-active-color-primary",
                  onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.deletebranchmodalhidebutton()))
                }, [
                  _createElementVNode("span", _hoisted_99, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_100, [
                _createVNode(_component_el_row, {
                  justify: "space-between",
                  type: "flex"
                }, {
                  default: _withCtx(() => [
                    _hoisted_101,
                    _hoisted_102,
                    _createElementVNode("p", null, _toDisplayString(this.deletebranchmodal.branchcode), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  justify: "space-between",
                  type: "flex"
                }, {
                  default: _withCtx(() => [
                    _hoisted_103,
                    _hoisted_104,
                    _createElementVNode("p", null, _toDisplayString(this.deletebranchmodal.branchname), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_105, [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      plain: "",
                      size: "mini",
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.deleteBranch())),
                      loading: this.deletebranchmodal.savebuttonloading
                    }, {
                      default: _withCtx(() => [
                        _hoisted_106
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_el_button, {
                      type: "info",
                      plain: "",
                      size: "mini",
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.deletebranchmodalhidebutton()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_107
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}